//#region react import
//#endregion

//#region component import
import GlobalLayout from "../../../Layout/GlobalLayout/GlobalLayout.component";
import TrainingDetailLayout from "../../../Layout/TrainingDetailLayout/TrainingDetailLayout.component";
//#endregion

//#region functions import
import ScrollToTopController from "../../../Helper/CustomHook/ScrollToTopController";
//#endregion

//#region constants import
import { CONVERSION_PATH } from "../../../Constants/IconConstants";
import { TRAININGS_DETAILS } from "../../../Routing/PageNames";
//#endregion

const TrainingHomeDetail = () => {
  return (
    <GlobalLayout
      icon={CONVERSION_PATH}
      title={TRAININGS_DETAILS.pageTraductionKey}
    >
      <ScrollToTopController />
      <TrainingDetailLayout />
    </GlobalLayout>
  );
};

export default TrainingHomeDetail;
